(function () {
  "use strict";

  if (window.__vtKz) return;
  window.__vtKz = true;

  window.VTCatalogus = (function () {
    var SLEUTEL = "vt-catalogus:" + (document.documentElement.lang || "");
    var data = null;
    var belofte = null;

    function uitPagina() {
      var sc = document.querySelector("script[data-fit-data]");
      if (!sc) return null;
      try { return JSON.parse(sc.textContent); } catch (e) { return null; }
    }
    function inPagina(tekst) {
      if (document.querySelector("script[data-fit-data]")) return;
      var el = document.createElement("script");
      el.type = "application/json";
      el.setAttribute("data-fit-data", "");
      el.textContent = tekst;
      document.body.appendChild(el);
    }
    function adres() {
      var wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      return wortel + "?sections=vt-autos-data";
    }

    function laad() {
      if (data) return Promise.resolve(data);
      data = uitPagina();
      if (data) return Promise.resolve(data);
      try {
        var bewaard = sessionStorage.getItem(SLEUTEL);
        if (bewaard) {
          data = JSON.parse(bewaard);
          inPagina(bewaard);
          return Promise.resolve(data);
        }
      } catch (e) { data = null; }

      if (!belofte) {
        belofte = fetch(adres(), { headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error("catalogus")); })
          .then(function (d) {
            var tmp = document.createElement("div");
            tmp.innerHTML = d["vt-autos-data"] || "";
            var sc = tmp.querySelector("script[data-fit-data]");
            if (!sc) throw new Error("catalogus leeg");
            data = JSON.parse(sc.textContent);
            var compact = JSON.stringify(data);
            try { sessionStorage.setItem(SLEUTEL, compact); } catch (e) {  }
            inPagina(compact);
            return data;
          })
          .catch(function (e) { belofte = null; throw e; });
      }
      return belofte;
    }

    return { laad: laad, nu: function () { return data || uitPagina(); } };
  })();

  ["focusin", "pointerdown"].forEach(function (soort) {
    document.addEventListener(soort, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest("[data-fit-merk], [data-vt-merk], [data-kz-plaat], [data-kz-tab]")) {
        window.VTCatalogus.laad().catch(function () {});
      }
    }, true);
  });

  var REEKSEN = [
    /^[A-Z]{2}\d{4}$/,
    /^\d{4}[A-Z]{2}$/,
    /^\d{2}[A-Z]{2}\d{2}$/,
    /^[A-Z]{2}\d{2}[A-Z]{2}$/,
    /^[A-Z]{4}\d{2}$/,
    /^\d{2}[A-Z]{4}$/,
    /^\d{2}[A-Z]{3}\d$/,
    /^\d[A-Z]{3}\d{2}$/,
    /^[A-Z]{2}\d{3}[A-Z]$/,
    /^[A-Z]\d{3}[A-Z]{2}$/,
    /^[A-Z]{3}\d{2}[A-Z]$/,
    /^[A-Z]\d{2}[A-Z]{3}$/,
    /^\d[A-Z]{2}\d{3}$/,
    /^\d{3}[A-Z]{2}\d$/
  ];

  function geldigeReeks(plaat) {
    for (var i = 0; i < REEKSEN.length; i++) if (REEKSEN[i].test(plaat)) return true;
    return false;
  }

  var RDW_VOERTUIG  = "https://opendata.rdw.nl/resource/m9d7-ebf2.json?kenteken=";
  var RDW_BRANDSTOF = "https://opendata.rdw.nl/resource/8ys7-d773.json?kenteken=";

  var KNOPPEN = "[data-kh-verder],[data-keuzehulp-go],[data-fit-go],[data-vt-go]";

  var TYPE1 = [
    { merk: "NISSAN",     naam: "LEAF",      tot: "20180101" },
    { merk: "FIAT",       naam: "500",       tot: "20200101" },
    { merk: "MITSUBISHI", naam: "OUTLANDER", tot: "20250101" },
    { merk: "MITSUBISHI", naam: "I-MIEV" },
    { merk: "PEUGEOT",    naam: "ION" },
    { merk: "CITROEN",    naam: "C-ZERO" },
    { merk: "RENAULT",    naam: "KANGOO",    tot: "20170101" },
    { merk: "KIA",        naam: "SOUL",      tot: "20190101" },
    { merk: "NISSAN",     naam: "NV200" },
    { merk: "TOYOTA",     naam: "PRIUS",     tot: "20170101" }
  ];

  var tekstenCache;
  function teksten() {
    if (tekstenCache !== undefined) return tekstenCache;
    tekstenCache = {};
    var sc = document.querySelector("script[data-kz-teksten]");
    if (sc) { try { tekstenCache = JSON.parse(sc.textContent) || {}; } catch (e) { tekstenCache = {}; } }
    return tekstenCache;
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function bericht(sleutel, waarden) {
    var uit = esc(teksten()[sleutel] || "");
    Object.keys(waarden || {}).forEach(function (k) {
      var w = k === "reden" ? waarden[k] : esc(waarden[k]);
      if (k === "auto") w = "<b>" + w + "</b>";
      uit = uit.replace(new RegExp("\\{\\{\\s*" + k + "\\s*\\}\\}", "g"), w);
    });
    return uit;
  }

  function woordenVan(s) {
    var t = String(s == null ? "" : s).toUpperCase().replace(/\+/g, " PLUS ");
    if (t.normalize) t = t.normalize("NFD").replace(/[̀-ͯ]/g, "");
    return t.replace(/[^A-Z0-9]+/g, " ").trim().split(" ").filter(Boolean);
  }

  function N(s) { return woordenVan(s).join(""); }

  function naamVan(optie) {
    return (optie && (optie.getAttribute("data-naam") || optie.textContent) || "").trim();
  }

  function getal(v) {
    if (v === null || v === undefined || v === "") return null;
    var n = parseFloat(String(v).replace(",", "."));
    return isNaN(n) ? null : n;
  }

  function lijstUit(json) {
    if (!json) return [];
    try { var l = JSON.parse(json); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }

  function modelKlasse(naam) {
    var w = woordenVan(naam);
    function heeft(x) { return w.indexOf(x) !== -1; }

    if (heeft("PHEV") || heeft("HYBRID") || heeft("HYBRIDE") || heeft("EHYBRID") ||
        heeft("GTE") || heeft("4XE") || (heeft("PLUG") && heeft("IN")) ||
        (heeft("TFSI") && heeft("E"))) return "PHEV";

    if (heeft("ELECTRIC") || heeft("ELEKTRISCH") || heeft("BEV") || heeft("EV") ||
        heeft("ZE") || (w[0] === "E" && w.length > 1 && w[1] !== "KLASSE")) return "BEV";
    for (var i = 0; i < w.length - 1; i++) if (w[i] === "E" && w[i + 1] === "TRON") return "BEV";

    return "";
  }

  function rdwKlasse(volledigElektrisch) {
    if (volledigElektrisch === true) return "BEV";
    if (volledigElektrisch === false) return "PHEV";
    return "";
  }

  function pastAandrijving(m, klasse) {
    var mk = modelKlasse(m && m.naam);
    return !klasse || !mk || mk === klasse;
  }

  function jaarBereik(tekst) {
    if (!tekst) return null;
    var jaren = String(tekst).match(/\d{4}/g);
    if (!jaren || !jaren.length) return null;
    var vanaf = parseInt(jaren[0], 10);
    var tot = jaren.length > 1 ? parseInt(jaren[1], 10) : null;
    if (/heden|nu|nog/i.test(tekst)) tot = null;
    return { vanaf: vanaf, tot: tot };
  }

  function binnenBouwjaren(m, voertuig) {
    var bereik = jaarBereik(m && m.bouwjaren);
    var jaar = parseInt(String(voertuig && voertuig.datum_eerste_toelating || "").slice(0, 4), 10);
    if (!bereik || !jaar) return true;
    if (jaar < bereik.vanaf - 1) return false;
    if (bereik.tot && jaar > bereik.tot + 1) return false;
    return true;
  }

  function vingerafdruk(v) {
    return [v && v.typegoedkeuringsnummer, v && v.variant, v && v.uitvoering]
      .filter(Boolean).join("|");
  }

  function termPast(term, v, klasse) {
    var raw = String(term || "").trim();
    if (!raw || !v) return false;

    var sep = raw.indexOf("|");
    if (sep > 0) {
      var vereist = raw.slice(0, sep).trim().toUpperCase();
      if (vereist === "BEV" || vereist === "PHEV") {
        if (klasse !== vereist) return false;
        raw = raw.slice(sep + 1);
      }
    }

    var pos = raw.indexOf(":");
    var sleutel = pos > 0 ? raw.slice(0, pos).trim().toUpperCase() : "";
    var wil = N(pos > 0 ? raw.slice(pos + 1) : raw);
    if (!wil) return false;

    var velden = {
      HB: v.handelsbenaming,
      TYPE: v.type,
      VARIANT: v.variant,
      UITVOERING: v.uitvoering,
      TGK: v.typegoedkeuringsnummer,
      FP: vingerafdruk(v)
    };
    if (sleutel) {
      return Object.prototype.hasOwnProperty.call(velden, sleutel) && N(velden[sleutel]) === wil;
    }
    return Object.keys(velden).some(function (k) { return N(velden[k]) === wil; });
  }

  function heeftTerm(item, v, klasse) {
    return Array.isArray(item && item.rdw_zoektermen) && item.rdw_zoektermen.some(function (t) {
      return termPast(t, v, klasse);
    });
  }

  var AANDRIJFWOORDEN = ["ELECTRIC", "ELEKTRISCH", "BEV", "EV", "PHEV", "PLUG", "IN", "HYBRID",
    "HYBRIDE", "EHYBRID", "RECHARGE", "GTE", "4XE"];

  function basisnaam(naam) {
    var w = woordenVan(naam);
    var uit = [];
    var aandrijving = false;

    w.forEach(function (x, i) {
      var vorige = w[i - 1], volgende = w[i + 1], daarna = w[i + 2];
      if (AANDRIJFWOORDEN.indexOf(x) !== -1) { aandrijving = true; return; }
      if (aandrijving && /^\d{2,3}$/.test(x)) return;
      if (x === "E" && ((i === 0 && volgende !== "KLASSE") ||
                        volgende === "TECH" || volgende === "HYBRID")) return;
      if (x === "TECH" && vorige === "E") { aandrijving = true; return; }
      if (/^\d$/.test(x) && volgende === "E" && daarna === "HYBRID") return;
      uit.push(x);
    });

    var t = uit.join(" ");
    t = t.replace(/\s+\d{2,3}\s+(?:E|DE)(?:\s+4MATIC)?$/, "");
    t = t.replace(/\s+\d{2}\s+TFSI\s+E(?:\s+QUATTRO)?$/, "");
    t = t.replace(/\s+(?:XDRIVE|SDRIVE)\d+E$/, "");
    t = t.replace(/\s+T[5-8](?:\s+AWD)?$/, "");
    t = t.replace(/\s+(?:LONG RANGE|STANDARD RANGE|EXTENDED RANGE|PERFORMANCE)$/, "");
    return N(t);
  }

  var autosCache;

  function autos() {
    if (autosCache) return autosCache;
    autosCache = window.VTCatalogus.nu();
    return autosCache;
  }

  function uitOptie(o) {
    return {
      naam: naamVan(o),
      bouwjaren: o.getAttribute("data-bouwjaren") || "",
      kw: getal(o.getAttribute("data-kw")),
      fasen: getal(o.getAttribute("data-fasen")),
      rdw_zoektermen: lijstUit(o.getAttribute("data-rdw")),
      varianten: lijstUit(o.getAttribute("data-varianten"))
    };
  }

  function kandidaten(select, merkHandle) {
    var lijst = (autos() || {})[merkHandle] || null;
    var uit = [];
    Array.prototype.forEach.call(select.options, function (o) {
      if (!o.value || o.hidden || o.disabled) return;
      var bij = o.getAttribute("data-merk");
      if (bij && bij !== merkHandle) return;
      var m = lijst && /^\d+$/.test(o.value) ? lijst[parseInt(o.value, 10)] : null;
      if (!m || N(m.naam) !== N(naamVan(o))) m = uitOptie(o);
      uit.push({ optie: o, m: m });
    });
    return uit;
  }

  function merkOptie(select, merk) {
    var wil = N(merk);
    if (!wil) return null;
    var opties = Array.prototype.filter.call(select.options, function (o) {
      return o.value && !o.disabled;
    });

    var exact = opties.filter(function (o) { return N(naamVan(o)) === wil; });
    if (exact.length) return exact.length === 1 ? exact[0] : null;

    var herkend = opties.filter(function (o) {
      return lijstUit(o.getAttribute("data-rdw")).some(function (term) {
        var t = String(term || "").trim();
        var pos = t.indexOf(":");
        if (pos > 0) {
          if (t.slice(0, pos).trim().toUpperCase() !== "MERK") return false;
          t = t.slice(pos + 1);
        }
        return N(t) === wil;
      });
    });
    return herkend.length === 1 ? herkend[0] : null;
  }

  function vindModel(lijst, voertuig, klasse, soepel) {
    soepel = soepel || {};
    var mogelijk = lijst.filter(function (k) {
      return (soepel.aandrijving || pastAandrijving(k.m, klasse)) &&
             (soepel.jaar || binnenBouwjaren(k.m, voertuig));
    });
    function enige(raak) { return raak.length === 1 ? raak[0] : null; }

    var alias = mogelijk.filter(function (k) {
      return heeftTerm(k.m, voertuig, klasse) ||
        (k.m.varianten || []).some(function (v) { return heeftTerm(v, voertuig, klasse); });
    });
    if (alias.length) return enige(alias);

    var r = opNaam(mogelijk, voertuig && voertuig.handelsbenaming);
    if (r !== undefined) return r;

    var kaal = zonderMerk(voertuig);
    if (!kaal) return null;
    var streng = mogelijk.filter(function (k) {
      var mk = modelKlasse(k.m.naam);
      return !klasse || mk === klasse || (klasse === "BEV" && mk === "");
    });
    r = opNaam(streng, kaal);
    return r === undefined ? null : r;
  }

  function opNaam(lijst, naam) {
    var hb = N(naam);
    if (!hb) return undefined;
    var exact = lijst.filter(function (k) { return N(k.m.naam) === hb; });
    if (exact.length) return exact.length === 1 ? exact[0] : null;
    var sleutel = basisnaam(naam);
    if (!sleutel) return undefined;
    var basis = lijst.filter(function (k) { return basisnaam(k.m.naam) === sleutel; });
    if (basis.length) return basis.length === 1 ? basis[0] : null;
    return undefined;
  }

  function zonderMerk(voertuig) {
    var w = woordenVan(voertuig && voertuig.handelsbenaming), m = woordenVan(voertuig && voertuig.merk);
    var voorop = m.length && w.length > m.length && m.every(function (x, i) { return w[i] === x; });
    return voorop ? w.slice(m.length).join(" ") : null;
  }

  var MARGE_VOOR_MAANDEN = 1;
  var MARGE_NA_MAANDEN = 12;

  function maandNummer(s) {
    var d = String(s || "").replace(/[^0-9]/g, "");
    if (d.length < 4) return null;
    var jaar = parseInt(d.slice(0, 4), 10);
    var maand = d.length >= 6 ? parseInt(d.slice(4, 6), 10) : 1;
    return jaar * 12 + (maand - 1);
  }

  function variantPeriode(v) {
    var vanaf = maandNummer(v.productie_vanaf);
    var tot = maandNummer(v.productie_tot);
    return vanaf === null && tot === null ? null : { vanaf: vanaf, tot: tot };
  }

  function soortVan(v) { return String(v && v.soort || "").toLowerCase(); }

  function variantKeuze(m, voertuig, klasse) {
    var vs = m && m.varianten ? m.varianten : [];
    if (!vs.length) return null;

    var herkend = [];
    vs.forEach(function (v, i) { if (heeftTerm(v, voertuig, klasse)) herkend.push(i); });
    if (herkend.length === 1) return { index: herkend[0], bron: "herkenning" };
    if (herkend.length > 1) return null;

    if (vs.length === 1) return { index: 0, bron: "enige" };

    var datum = maandNummer(voertuig && voertuig.datum_eerste_toelating);
    var opPeriode = function (v) {
      var s = soortVan(v);
      return s === "bouwjaar" || s === "modeljaar";
    };
    if (datum === null || !vs.some(opPeriode)) return null;

    var binnen = [];
    vs.forEach(function (v, i) {
      var vk = modelKlasse(v.naam);
      if (klasse && vk && vk !== klasse) return;
      var p = opPeriode(v) ? variantPeriode(v) : null;
      if (p && p.vanaf !== null && datum < p.vanaf - MARGE_VOOR_MAANDEN) return;
      if (p && p.tot !== null && datum > p.tot + MARGE_NA_MAANDEN) return;
      binnen.push(i);
    });
    if (binnen.length === 1) return { index: binnen[0], bron: "periode" };
    return zelfdeKabel(vs, binnen);
  }

  function zelfdeKabel(vs, binnen) {
    if (binnen.length < 2 || !window.VTKabel) return null;
    var klassen = {}, aansl = {}, sterkste = null, max = -1;
    for (var n = 0; n < binnen.length; n++) {
      var v = vs[binnen[n]];
      var k = VTKabel.klasse(v);
      if (k === null || !v.aansluiting) return null;
      klassen[k] = true;
      aansl[v.aansluiting] = true;
      var s = VTKabel.stroom(v);
      if (s > max) { sterkste = binnen[n]; max = s; }
    }
    var soorten = Object.keys(aansl);
    if (Object.keys(klassen).length !== 1 || soorten.length !== 1 || VTKabel.isType1(soorten[0])) return null;
    return { index: sterkste, bron: "kabel" };
  }

  function controleer(m, volledigElektrisch) {
    var kw = getal(m && m.kw), fasen = getal(m && m.fasen);
    if (volledigElektrisch === true && modelKlasse(m && m.naam) !== "BEV" &&
        kw !== null && kw <= 3.7 && fasen === 1) {
      return bericht("reden_eenfase");
    }
    return null;
  }

  function reden(lijst, voertuig, klasse, volledigElektrisch) {
    if (vindModel(lijst, voertuig, klasse, { aandrijving: true })) {
      return bericht(volledigElektrisch ? "reden_bev" : "reden_phev");
    }
    if (vindModel(lijst, voertuig, klasse, { jaar: true })) {
      var jaar = String(voertuig.datum_eerste_toelating || "").slice(0, 4);
      return bericht("reden_jaar", { jaar: jaar });
    }
    return null;
  }

  function vuurAf(el) {
    ["input", "change"].forEach(function (naam) {
      el.dispatchEvent(new Event(naam, { bubbles: true }));
    });
  }

  function type1Voor(v) {
    var merk = N(v.merk), hb = N(v.handelsbenaming), det = v.datum_eerste_toelating || "";
    for (var i = 0; i < TYPE1.length; i++) {
      var t = TYPE1[i];
      if (N(t.merk) === merk && hb.indexOf(N(t.naam)) !== -1 && (!t.tot || (det && det < t.tot))) return t;
    }
    return null;
  }

  function wortelVan(kz) {
    return kz.closest("[data-vt-picker]") ||
           kz.closest("[data-kh]") ||
           kz.closest("[data-keuzehulp]") ||
           kz.closest("[data-fit]") ||
           kz.parentElement;
  }

  function veldenVan(kz) {
    var wortel = wortelVan(kz);
    return {
      wortel: wortel,
      merk:  wortel.querySelector("[data-fit-merk], [data-vt-merk]"),
      model: wortel.querySelector("[data-fit-model], [data-vt-model]"),
      uitvoering: wortel.querySelector("[data-uitvoering-kies]"),
      knop:  wortel.querySelector(KNOPPEN)
    };
  }

  function zetOverdracht(velden, m, keuze) {
    var zeker = keuze && keuze.bron !== "kabel";
    var v = zeker && m.varianten ? m.varianten[keuze.index] : null;
    if (v && v.handle) {
      velden.model.dataset.kzVoor = velden.merk.value + "/" + velden.model.value;
      velden.model.dataset.kzUitvoering = v.handle;
      velden.model.dataset.kzIndex = String(keuze.index);
    } else {
      wisOverdracht(velden.model);
    }
  }
  function wisOverdracht(select) {
    if (!select || !select.dataset) return;
    delete select.dataset.kzVoor;
    delete select.dataset.kzUitvoering;
    delete select.dataset.kzIndex;
  }

  function melding(kz, soort, tekst) {
    var el = kz.querySelector("[data-kz-melding]");
    if (!el) return;
    el.className = "vt-kz__melding vt-kz__melding--" + soort;
    el.innerHTML = tekst;
    el.hidden = false;
  }
  function meldingWeg(kz) {
    var el = kz.querySelector("[data-kz-melding]");
    if (el) { el.hidden = true; el.innerHTML = ""; }
  }

  function zetModus(kz, modus, metFocus) {
    kz.setAttribute("data-modus", modus);
    kz.querySelectorAll("[data-kz-tab]").forEach(function (t) {
      t.setAttribute("aria-selected", t.getAttribute("data-kz-tab") === modus ? "true" : "false");
    });
    kz.querySelectorAll("[data-kz-paneel]").forEach(function (p) {
      p.classList.toggle("is-aan", p.getAttribute("data-kz-paneel") === modus);
    });

    if (metFocus) meldingWeg(kz);

    if (!metFocus || modus !== "kenteken") return;
    setTimeout(function () {
      var el = kz.querySelector("[data-kz-plaat]");
      if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }, 200);
  }

  var doorlaten = false;

  function haal(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error("RDW " + r.status);
      return r.json();
    }).then(function (d) {
      if (!Array.isArray(d)) throw new Error("RDW gaf geen lijst");
      return d;
    });
  }

  function opzoeken(kz, knop) {
    var invoer = kz.querySelector("[data-kz-plaat]");
    var plaat  = N(invoer && invoer.value);
    if (plaat.length < 6) { if (invoer) invoer.focus(); return; }

    if (!geldigeReeks(plaat)) {
      melding(kz, "let", bericht("geen_nl"));
      if (invoer) invoer.focus();
      return;
    }

    var velden = veldenVan(kz);
    if (!velden.merk) { melding(kz, "let", bericht("laden")); return; }

    meldingWeg(kz);
    wisOverdracht(velden.model);
    knop.classList.add("is-bezig");
    knop.disabled = true;

    try { sessionStorage.setItem("vt_kenteken", invoer.value); } catch (e) {}

    Promise.all([
      haal(RDW_VOERTUIG + plaat),
      haal(RDW_BRANDSTOF + plaat),
      window.VTCatalogus.laad().catch(function () { return null; })
    ]).then(function (res) {
      var voertuig = res[0], brandstof = res[1];

      if (!voertuig.length) {
        melding(kz, "let", bericht("niet_gevonden"));
        return zetModus(kz, "merk", false);
      }

      var v = voertuig[0];
      var soorten = brandstof.map(function (b) { return b.brandstof_omschrijving; }).filter(Boolean);
      var elektrisch = soorten.some(function (b) { return b.toLowerCase().indexOf("elektriciteit") !== -1; });

      var brandbaar = soorten.filter(function (b) {
        return b.toLowerCase().indexOf("elektriciteit") === -1;
      });

      var klassen = brandstof.map(function (b) {
        return String(b.klasse_hybride_elektrisch_voertuig || "").toUpperCase();
      });
      var metStekker = klassen.indexOf("OVC-HEV") !== -1 || klassen.indexOf("OVC-FCHV") !== -1;
      var zonderStekker = klassen.indexOf("NOVC-HEV") !== -1 || klassen.indexOf("NOVC-FCHV") !== -1;

      if (zonderStekker && !metStekker) {
        return melding(kz, "let", bericht("hybride", { merk: v.merk }));
      }
      if (!elektrisch && !metStekker) {
        return melding(kz, "let", bericht("geen_stekker", {
          merk: v.merk,
          brandstof: soorten.join(" " + (teksten().en || "en") + " ") || teksten().brandstof_onbekend || ""
        }));
      }
      var volledigElektrisch = elektrisch && brandbaar.length === 0 && !metStekker;
      var klasse = rdwKlasse(volledigElektrisch);

      if (type1Voor(v)) {
        return melding(kz, "nee", bericht("type1", { auto: v.merk + " " + v.handelsbenaming }));
      }

      var mo = merkOptie(velden.merk, v.merk);
      if (!mo) {
        melding(kz, "let", bericht("merk_onbekend", { merk: v.merk }));
        return zetModus(kz, "merk", false);
      }
      velden.merk.value = mo.value;
      vuurAf(velden.merk);

      wachtOpModellen(velden, 0, function (gevuld) {
        var auto = v.merk + " " + v.handelsbenaming;
        if (!gevuld) {
          melding(kz, "ok", bericht("herkend_kies", { auto: auto }));
          return zetModus(kz, "merk", false);
        }

        var lijst = kandidaten(velden.model, velden.merk.value);
        var gevonden = vindModel(lijst, v, klasse);
        var bezwaar = gevonden
          ? controleer(gevonden.m, volledigElektrisch)
          : reden(lijst, v, klasse, volledigElektrisch);

        if (!gevonden || bezwaar) {
          velden.model.value = "";
          melding(kz, "let", bezwaar
            ? bericht("twijfel", { auto: auto, reden: bezwaar })
            : bericht("herkend_nog", { auto: auto }));
          zetModus(kz, "merk", false);
          try { velden.model.focus({ preventScroll: true }); } catch (e) {}
          return;
        }

        velden.model.value = gevonden.optie.value;
        vuurAf(velden.model);

        var keuze = variantKeuze(gevonden.m, v, klasse);
        var kies = velden.uitvoering;
        if (kies && !kies.closest("[hidden]") && keuze) {
          kies.value = String(keuze.index);
          vuurAf(kies);
        } else if (kies && !kies.closest("[hidden]")) {
          if (kies.value === "?") {
            melding(kz, "ok", bericht("onbekend_veilig", { auto: auto }));
          } else {
            melding(kz, "let", bericht("aansluiting_verschilt", { auto: auto }));
          }
          kz.dataset.kzBevestig = plaat;
          zetOverdracht(velden, gevonden.m, keuze);
          return;
        }
        zetOverdracht(velden, gevonden.m, keuze);

        doorlaten = true;
        setTimeout(function () {
          knop.click();
          doorlaten = false;
        }, 60);
      });

    }).catch(function () {
      melding(kz, "let", bericht("onbereikbaar"));
      zetModus(kz, "merk", false);
    }).then(function () {
      knop.classList.remove("is-bezig");
      knop.disabled = false;
    });
  }

  function wachtOpModellen(velden, poging, klaar) {
    if (!velden.model) return klaar(false);
    if (!velden.model.disabled && velden.model.options.length > 1) return klaar(true);
    if (poging >= 12) return klaar(false);
    setTimeout(function () { wachtOpModellen(velden, poging + 1, klaar); }, 150);
  }

  function formatteer(invoer) {
    var eind = invoer.selectionStart === invoer.value.length;
    var delen = N(invoer.value).match(/[A-Z]+|[0-9]+/g);
    invoer.value = delen ? delen.join("-") : "";
    if (eind) invoer.setSelectionRange(invoer.value.length, invoer.value.length);
  }

  function koppel(kz) {
    if (kz.dataset.kzKlaar) return;
    kz.dataset.kzKlaar = "1";

    kz.querySelectorAll("[data-kz-tab]").forEach(function (t) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        zetModus(kz, t.getAttribute("data-kz-tab"), true);
      });
    });

    var invoer = kz.querySelector("[data-kz-plaat]");
    if (invoer) {
      invoer.addEventListener("input", function () {
        formatteer(invoer);
        delete kz.dataset.kzBevestig;
      });
      invoer.addEventListener("keydown", function (e) {
        if (e.key !== "Enter") return;
        e.preventDefault();
        var knop = veldenVan(kz).knop;
        if (knop) knop.click();
      });
      try {
        var vorig = sessionStorage.getItem("vt_kenteken");
        if (vorig && !invoer.value) invoer.value = vorig;
      } catch (e) {}
    }
  }

  document.addEventListener("click", function (e) {
    if (doorlaten) return;
    var knop = e.target.closest ? e.target.closest(KNOPPEN) : null;
    if (!knop) return;

    var wortel = knop.closest("[data-vt-picker], [data-kh], [data-keuzehulp], [data-fit]");
    if (!wortel) return;
    var kz = wortel.querySelector("[data-kz]");
    if (!kz || kz.getAttribute("data-modus") !== "kenteken") return;

    var plaatNu = N((kz.querySelector("[data-kz-plaat]") || {}).value);
    if (kz.dataset.kzBevestig && kz.dataset.kzBevestig === plaatNu) return;

    e.preventDefault();
    e.stopPropagation();
    opzoeken(kz, knop);
  }, true);

  function start() { document.querySelectorAll("[data-kz]").forEach(koppel); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  document.addEventListener("shopify:section:load", start);
  document.addEventListener("shopify:block:select", start);
})();
